import { render, staticRenderFns } from "./AngleLeftIcon.vue?vue&type=template&id=60e39e94&"
import script from "./AngleLeftIcon.vue?vue&type=script&lang=js&"
export * from "./AngleLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports